/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { mailEsgDatapointCommentCreated } from '../fn/mail/mail-esg-datapoint-comment-created';
import { MailEsgDatapointCommentCreated$Params } from '../fn/mail/mail-esg-datapoint-comment-created';
import { mailProfileManual } from '../fn/mail/mail-profile-manual';
import { MailProfileManual$Params } from '../fn/mail/mail-profile-manual';
import { mailShInternalMail } from '../fn/mail/mail-sh-internal-mail';
import { MailShInternalMail$Params } from '../fn/mail/mail-sh-internal-mail';
import { mailTicketEvent } from '../fn/mail/mail-ticket-event';
import { MailTicketEvent$Params } from '../fn/mail/mail-ticket-event';

@Injectable({ providedIn: 'root' })
export class MailService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mailShInternalMail()` */
  static readonly MailShInternalMailPath = '/mail/sh-internal-mail';

  /**
   * API to send email for SH team.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailShInternalMail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailShInternalMail$Response(params: MailShInternalMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return mailShInternalMail(this.http, this.rootUrl, params, context);
  }

  /**
   * API to send email for SH team.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailShInternalMail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailShInternalMail(params: MailShInternalMail$Params, context?: HttpContext): Observable<void> {
    return this.mailShInternalMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mailProfileManual()` */
  static readonly MailProfileManualPath = '/mail/profile-manual';

  /**
   * API to send email Profile Manual.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailProfileManual()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailProfileManual$Response(params: MailProfileManual$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return mailProfileManual(this.http, this.rootUrl, params, context);
  }

  /**
   * API to send email Profile Manual.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailProfileManual$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailProfileManual(params: MailProfileManual$Params, context?: HttpContext): Observable<void> {
    return this.mailProfileManual$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mailTicketEvent()` */
  static readonly MailTicketEventPath = '/mail/ticket-event';

  /**
   * API to send email ticket event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailTicketEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailTicketEvent$Response(params: MailTicketEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return mailTicketEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * API to send email ticket event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailTicketEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailTicketEvent(params: MailTicketEvent$Params, context?: HttpContext): Observable<void> {
    return this.mailTicketEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mailEsgDatapointCommentCreated()` */
  static readonly MailEsgDatapointCommentCreatedPath = '/mail/esg-datapoint-comment-created';

  /**
   * ESG Datapoint Comment Created.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mailEsgDatapointCommentCreated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailEsgDatapointCommentCreated$Response(params: MailEsgDatapointCommentCreated$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return mailEsgDatapointCommentCreated(this.http, this.rootUrl, params, context);
  }

  /**
   * ESG Datapoint Comment Created.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mailEsgDatapointCommentCreated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mailEsgDatapointCommentCreated(params: MailEsgDatapointCommentCreated$Params, context?: HttpContext): Observable<void> {
    return this.mailEsgDatapointCommentCreated$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
